<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Cadastro de Produtos</app-titulo>
      <div class="header-buttons">
        <app-botao type="primario" class="button" text="Cadastrar Produto" icon="assets/add.svg"
          (click)="navegarCadastro()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Listagem de Produtos</div>
        <div class="align-button">
          <form [formGroup]="form" class="table-filters">
            <app-input label="Nome do Produto" placeholder="Digite aqui" name="NM_PROD" formControlName="NM_PROD"
              width="100%"></app-input>
            <app-input type="select" label="Status" name="NU_STTS" formControlName="NU_STTS" width="100%"
              [selectData]="statusOptions" (ngModelChange)="onChangeStatus($event)"></app-input>
          </form>
        </div>
      </div>
      <app-tabela *ngIf="!isLoading" [data]="tableData" [columns]="tableColumns"></app-tabela>
      <div class="paginacao">
        <app-paginacao *ngIf="maxPages > 1" [pages]="maxPages" (selectedPage)="mudarPagina($event)"></app-paginacao>
      </div>
    </div>
  </div>
  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input label="Nome do Produto" name="NM_PROD" formControlName="NM_PROD" width="100%"></app-input>
      <app-input type="select" label="Status" name="NU_STTS" formControlName="NU_STTS" width="100%"
        [selectData]="statusOptions" (ngModelChange)="onChangeStatus($event)"></app-input>
    </form>
    <app-card *ngIf="!isLoading" [data]="tableData" [rows]="tableColumns" [expand]="expandirCardsMobile"></app-card>
    <div class="paginacao">
      <app-paginacao *ngIf="maxPages > 1" [pages]="maxPages" (selectedPage)="mudarPagina($event)"></app-paginacao>
    </div>
  </div>
  <app-subtitulo *ngIf="!isLoading && !tableData.length">Nenhum registro encontrado.</app-subtitulo>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
